export enum TaskActionType {
  CLIENT = 'CLIENT',
  LINK = 'LINK',
  INTAKE = 'INTAKE'
}
